module.exports = __webpack_public_path__ + "img/face-1.97fb9581.jpg";